/* Eigen cookiebanner, op 25-10-2026 letterlijk nagebouwd naar de Consentmo-banner
   die toen live stond (layout Banner, kleuren Custom, Accept all en Reject all
   allebei #1A1A1A: ICO "equally prominent", zijn keuze van 18-10). Daarna is de
   Consentmo-embed uitgezet in config/settings_data.json.

   Wat Consentmo deed en dit bestand nu doet:
   - Google Consent Mode: default "denied" staat inline bovenaan layout/theme.liquid
     (moet vóór de tags); hier alleen de update na een keuze.
   - Shopify Customer Privacy API: setTrackingConsent. Daar luisteren Shopify's
     eigen pixels, de Google-app, Clarity, TrackBee en onze brand-gedrag.js,
     brand-meekijken.js en brand-chat.js naar.
   - dataLayer-event consent_status, zoals Consentmo het voor GTM stuurde.
   - Schuifjes staan bij openen uit. Vooraf aan is in het VK geen geldige
     toestemming (UK GDPR/PECR); niet veranderen zonder zijn expliciete keuze.

   De keuze staat in cookie draycott_consent ("a1m0p1" = analytics, marketing,
   preferences), een jaar geldig. Bezoekers die al bij Consentmo kozen worden
   door het inline script uit hun oude cookies overgenomen en zien niets nieuws.

   Shadow DOM, net als Consentmo: zo komt de thema-CSS van Broadcast niet aan de
   knoppen. Een link naar #cookie-preferences opent de voorkeuren opnieuw, want
   intrekken moet net zo makkelijk zijn als geven. */
(function () {
  if (window.__draycottCookies) return;
  window.__draycottCookies = true;

  /* Consentmo sloeg headless browsers en crawlers over; PageSpeed meet dan de
     pagina zonder banner, zoals voorheen. */
  if (/HeadlessChrome|Lighthouse|bot|crawl|spider/i.test(navigator.userAgent)) return;

  var TEKST = 'We use cookies to understand our audience better and to show you relevant ads, including with partners such as Google. You can change your choice at any time.';
  var CATS = [
    { k: 'n', t: 'Necessary', d: 'Essential for the website to function properly, these cookies enable core features such as security, page navigation, and access to secure areas. They cannot be disabled.', p: ['Shopify', 'Triple Whale', 'Shopify Theme'] },
    { k: 'a', t: 'Statistics', d: 'By collecting anonymous data, these cookies help us understand how visitors interact with the website, allowing us to improve performance and user experience.', p: ['Shopify', 'Microsoft Clarity', 'Bugsnag', 'TrackBee', 'Triple Whale'] },
    { k: 'm', t: 'Marketing', d: 'These cookies track your activity across websites to deliver personalized ads and relevant content. They also help measure the effectiveness of our marketing campaigns.', p: ['Google Ads', 'Shopify', 'CAPI Automation', 'TikTok Pixel'] },
    { k: 'p', t: 'Preferences', d: 'These cookies remember your choices - such as language preferences or login details - to provide a more personalized experience.', p: ['Shopify', 'Google'] }
  ];

  var CSS =
    ':host{all:initial;font-family:inherit;font-size:16px;color:#303030}' +
    '*{box-sizing:border-box}' +
    'button{font-family:inherit}' +
    '.bar{position:fixed;left:0;right:0;bottom:0;z-index:2147483647;background:#f7f7f7;color:#303030;box-shadow:0 0 20px rgba(0,0,0,.1);font-size:16px}' +
    '.body{display:flex;align-items:center;justify-content:space-between;gap:17px;padding:14px 24px}' +
    '.msg{margin:0;text-align:left}' +
    '.msg a{color:inherit;display:inline-block;opacity:.8;padding:.2em;text-decoration:underline}' +
    '.knoppen{display:flex;align-items:stretch;column-gap:.4rem;flex:0 0 auto}' +
    '.btn{flex:0 0 auto;min-height:40px;padding:6px 12px;border:1px solid #1a1a1a;border-radius:3px;background:#1a1a1a;color:#fff;font-size:14px;font-weight:600;line-height:normal;cursor:pointer;text-align:center;transition:all .3s ease}' +
    '.btn:hover{background:#424242;border-color:#424242}' +
    '.btn.licht{background:transparent;color:#303030;border-color:#303030}' +
    '.btn.licht:hover{background:#545454;border-color:#545454;color:#f7f7f7}' +
    '.btn:focus-visible,.x:focus-visible,.pijl:focus-visible,.msg a:focus-visible{outline:2px solid #303030;outline-offset:2px}' +
    '@media (max-width:1025px){.body{flex-direction:column;align-items:stretch;gap:0}.knoppen{margin-top:12px;width:100%}}' +
    /* Mobiel compact (18-10): knoppen naast elkaar en even breed, kleinere tekst. */
    '@media (max-width:767px){.body{padding:12px 14px}.msg{font-size:13px;line-height:1.4;margin:0 0 10px}.knoppen{margin-top:19px;flex-direction:row-reverse;gap:6px}.knoppen .btn{flex:1 1 0;min-width:0;padding:6px 4px;font-size:13px;white-space:nowrap}}' +
    '@media (max-width:640px){.bar{left:19px;right:19px;bottom:16px;border-radius:6px}}' +
    /* Voorkeuren */
    '.waas{position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;padding:15px}' +
    '.dlg{width:700px;max-width:100%;max-height:calc(100vh - 170px);display:flex;flex-direction:column;background:#f7f7f7;color:#303030;border-radius:8px;box-shadow:0 0 20px rgba(0,0,0,.1);font-size:16px;line-height:22px;outline:none}' +
    '.kop{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;padding:30px 30px 20px}' +
    '.kop p{margin:0;font-size:17px;font-weight:600;line-height:1.35}' +
    '.x{background:none;border:0;padding:0;width:16px;height:16px;cursor:pointer;color:#303030;flex:0 0 auto}' +
    '.lijst{flex:1 1 auto;overflow:auto;max-height:544px;padding:15px 20px 20px 30px;border-top:1px solid rgba(128,128,128,.2)}' +
    '.uitleg{font-size:14px;line-height:1.45;margin:0 0 15px}' +
    '.rij{display:flex;justify-content:space-between;align-items:center}' +
    '.titel{display:flex;align-items:center;gap:4px;font-weight:600}' +
    '.pijl{background:none;border:0;padding:0 4px;cursor:pointer;color:#303030;display:flex;align-items:center}' +
    '.pijl svg{transition:transform .25s}.pijl[aria-expanded=true] svg{transform:rotate(180deg)}' +
    '.cat{font-size:14px;line-height:1.43;margin:4px 0 0}' +
    '.prov{margin:8px 0 0;padding:0 0 0 18px;font-size:14px;line-height:1.6}' +
    'hr{border:0;height:1px;background:rgba(128,128,128,.2);margin:15px 0}' +
    '.sw{position:relative;display:inline-block;width:44px;height:24px;flex:0 0 auto}' +
    '.sw input{opacity:0;width:0;height:0;position:absolute}' +
    '.sl{position:absolute;inset:0;border-radius:34px;background:#ccc;cursor:pointer;transition:.3s}' +
    '.sl:before{content:"";position:absolute;width:18px;height:18px;left:3px;top:3px;border-radius:50%;background:#fff;transition:.3s}' +
    '.sw input:checked+.sl{background:#303030}.sw input:checked+.sl:before{transform:translateX(20px)}' +
    '.sw input:disabled+.sl{opacity:.6;cursor:default}' +
    '.sw input:focus-visible+.sl{outline:2px solid #303030;outline-offset:2px}' +
    '.voet{display:flex;gap:6.4px;padding:20px 30px 30px}.voet .btn{flex:1}' +
    '@media (max-width:500px){.voet{flex-direction:column-reverse;gap:6px}}';

  var PIJL = '<svg width="14" height="9" viewBox="0 0 14 9" aria-hidden="true"><path d="M1 1l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
  var KRUIS = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.5"/></svg>';

  var host, sr, bar, waas, terugFocus;

  function api(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy && S.customerPrivacy.setTrackingConsent) return cb(S.customerPrivacy);
    if (S && S.loadFeatures) {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && S.customerPrivacy) cb(S.customerPrivacy);
      });
    }
  }

  function bewaar(t, status) {
    var v = 'a' + (+t.a) + 'm' + (+t.m) + 'p' + (+t.p);
    document.cookie = 'draycott_consent=' + v + '; path=/; max-age=31536000; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    window.draycottToestemming = t;
    function s(j) { return j ? 'granted' : 'denied'; }
    window.dataLayer = window.dataLayer || [];
    (function () { window.dataLayer.push(arguments); })('consent', 'update', { ad_storage: s(t.m), ad_user_data: s(t.m), ad_personalization: s(t.m), analytics_storage: s(t.a), functionality_storage: s(t.p), personalization_storage: s(t.p), security_storage: 'granted' });
    window.dataLayer.push({ event: 'consent_status', status: status, categories: [{ necessary: true, analytics: t.a, marketing: t.m, functionality: t.p }] });
    api(function (p) { p.setTrackingConsent({ analytics: t.a, marketing: t.m, preferences: t.p }, function () {}); });
    sluitVoorkeuren();
    if (bar) { bar.remove(); bar = null; }
  }

  function knop(tekst, soort, fn) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'btn' + (soort ? ' ' + soort : '');
    b.textContent = tekst;
    b.addEventListener('click', fn);
    return b;
  }

  function alles(j) { return { a: j, m: j, p: j }; }

  function zetHost() {
    if (host) return;
    host = document.createElement('div');
    host.id = 'draycott-cookies';
    sr = host.attachShadow({ mode: 'open' });
    var st = document.createElement('style');
    st.textContent = CSS;
    sr.appendChild(st);
    document.body.appendChild(host);
  }

  function toonBalk() {
    zetHost();
    bar = document.createElement('div');
    bar.className = 'bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Cookie bar');
    var body = document.createElement('div');
    body.className = 'body';
    var p = document.createElement('p');
    p.className = 'msg';
    p.id = 'draycott-cookie-tekst';
    p.textContent = TEKST;
    var a = document.createElement('a');
    a.href = '/policies/privacy-policy';
    a.textContent = 'Privacy Policy';
    p.appendChild(a);
    var k = document.createElement('div');
    k.className = 'knoppen';
    k.setAttribute('role', 'group');
    k.setAttribute('aria-label', 'Cookie consent actions');
    var pref = knop('Preferences', 'licht', function () { openVoorkeuren(pref); });
    pref.setAttribute('aria-haspopup', 'dialog');
    k.appendChild(pref);
    k.appendChild(knop('Reject all', '', function () { bewaar(alles(false), 'reject_all'); }));
    k.appendChild(knop('Accept all', '', function () { bewaar(alles(true), 'accept_all'); }));
    body.appendChild(p);
    body.appendChild(k);
    bar.appendChild(body);
    sr.appendChild(bar);
  }

  function openVoorkeuren(van) {
    zetHost();
    if (waas) return;
    terugFocus = van || document.activeElement;
    var t = window.draycottToestemming || alles(false);
    waas = document.createElement('div');
    waas.className = 'waas';
    waas.setAttribute('role', 'presentation');
    var d = document.createElement('div');
    d.className = 'dlg';
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    d.setAttribute('aria-labelledby', 'dc-kop');
    d.tabIndex = -1;

    var kop = document.createElement('div');
    kop.className = 'kop';
    kop.innerHTML = '<p id="dc-kop">Select the Types of Cookies You Accept</p>';
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'x';
    x.setAttribute('aria-label', 'Close');
    x.innerHTML = KRUIS;
    x.addEventListener('click', sluitVoorkeuren);
    kop.appendChild(x);

    var lijst = document.createElement('div');
    lijst.className = 'lijst';
    var uitleg = document.createElement('p');
    uitleg.className = 'uitleg';
    uitleg.textContent = 'Choose which cookies we can use. Necessary cookies are always on. You can change your choices at any time in the cookie settings.';
    lijst.appendChild(uitleg);
    var vinkjes = {};
    CATS.forEach(function (c, i) {
      var sec = document.createElement('div');
      var rij = document.createElement('div');
      rij.className = 'rij';
      var titel = document.createElement('div');
      titel.className = 'titel';
      var naam = document.createElement('span');
      naam.id = 'dc-t-' + c.k;
      naam.textContent = c.t;
      var pijl = document.createElement('button');
      pijl.type = 'button';
      pijl.className = 'pijl';
      pijl.setAttribute('aria-expanded', 'false');
      pijl.setAttribute('aria-label', 'Show details ' + c.t);
      pijl.innerHTML = PIJL;
      titel.appendChild(naam);
      titel.appendChild(pijl);
      var sw = document.createElement('label');
      sw.className = 'sw';
      var inp = document.createElement('input');
      inp.type = 'checkbox';
      inp.setAttribute('aria-labelledby', naam.id);
      if (c.k === 'n') { inp.checked = true; inp.disabled = true; } else { inp.checked = !!t[c.k]; vinkjes[c.k] = inp; }
      var sl = document.createElement('span');
      sl.className = 'sl';
      sw.appendChild(inp);
      sw.appendChild(sl);
      rij.appendChild(titel);
      rij.appendChild(sw);
      var tekst = document.createElement('p');
      tekst.className = 'cat';
      tekst.textContent = c.d;
      var prov = document.createElement('ul');
      prov.className = 'prov';
      prov.hidden = true;
      c.p.forEach(function (n) { var li = document.createElement('li'); li.textContent = n; prov.appendChild(li); });
      pijl.addEventListener('click', function () {
        prov.hidden = !prov.hidden;
        pijl.setAttribute('aria-expanded', String(!prov.hidden));
      });
      sec.appendChild(rij);
      sec.appendChild(tekst);
      sec.appendChild(prov);
      lijst.appendChild(sec);
      lijst.appendChild(document.createElement('hr'));
    });

    var voet = document.createElement('div');
    voet.className = 'voet';
    voet.appendChild(knop('Save choices', 'licht', function () {
      bewaar({ a: vinkjes.a.checked, m: vinkjes.m.checked, p: vinkjes.p.checked }, 'custom');
    }));
    voet.appendChild(knop('Reject All', '', function () { bewaar(alles(false), 'reject_all'); }));
    voet.appendChild(knop('Accept All', '', function () { bewaar(alles(true), 'accept_all'); }));

    d.appendChild(kop);
    d.appendChild(lijst);
    d.appendChild(voet);
    waas.appendChild(d);
    waas.addEventListener('click', function (e) { if (e.target === waas) sluitVoorkeuren(); });
    waas.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') return sluitVoorkeuren();
      if (e.key !== 'Tab') return;
      /* Focus binnen de dialog houden. */
      var f = [].slice.call(d.querySelectorAll('button,input:not([disabled]),a[href]'));
      var eerste = f[0], laatste = f[f.length - 1], nu = sr.activeElement;
      if (e.shiftKey && (nu === eerste || nu === d)) { e.preventDefault(); laatste.focus(); }
      else if (!e.shiftKey && nu === laatste) { e.preventDefault(); eerste.focus(); }
    });
    sr.appendChild(waas);
    d.focus();
  }

  function sluitVoorkeuren() {
    if (!waas) return;
    waas.remove();
    waas = null;
    if (terugFocus && terugFocus.focus) try { terugFocus.focus(); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#cookie-preferences"]');
    if (!a) return;
    e.preventDefault();
    openVoorkeuren(a);
  });

  function start() {
    var t = window.draycottToestemming;
    if (!t) return toonBalk();
    /* Overgenomen Consentmo-keuze: in onze eigen cookie zetten, en Shopify
       bijwerken als die (bijvoorbeeld na verlopen) geen keuze meer kent. */
    if (!/(?:^|; )draycott_consent=/.test(document.cookie)) {
      document.cookie = 'draycott_consent=a' + (+t.a) + 'm' + (+t.m) + 'p' + (+t.p) + '; path=/; max-age=31536000; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    }
    api(function (p) {
      var c = p.currentVisitorConsent ? p.currentVisitorConsent() : null;
      if (c && c.analytics === '' && c.marketing === '') p.setTrackingConsent({ analytics: t.a, marketing: t.m, preferences: t.p }, function () {});
    });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
